import { UserAllScoresRaw, UserAllScoresV2Raw } from '../../dto/scores/cube/raw/user-all-scores.dto';
import { UserAllScoresResult, UserAllScoresDto } from '../../dto/scores/cube/mapped/user-all-scores-results.dto';
import { IWorkingSessionsAnalyticsActivityEnum, IWorkingSessionsAnalyticsActivityEnumV2 } from '../../enum/working-sessions-analytics-activity.enum';
import { IAllScoresMapper } from '../../interface/scores/scores-mapper.interface';

export class AllScoresMapper
  implements IAllScoresMapper
{
  persistenceToDomain(model: UserAllScoresRaw): UserAllScoresResult {
    return AllScoresMapper.persistenceToDomain(model);
  }
  domainToRest(
    entity: UserAllScoresResult
  ): UserAllScoresDto {
    return AllScoresMapper.domainToRest(entity);
  }
  static persistenceToDomain(
    model: UserAllScoresRaw
  ): UserAllScoresResult {
    if (!model) {
      console.log("Invalid result from scores query")
      return {}
    }
    if (Object.keys(model).length < 4) {
      console.log("At least one of the scores is missing data")
      return {}
    }
    return {
      screenTime: Number(
        model[
          IWorkingSessionsAnalyticsActivityEnum.TotalActivityDuration
        ]
      ) || 0,
      focus: Number(
        model[
          IWorkingSessionsAnalyticsActivityEnum.FocusPercentage
        ]
      ) || 0,
      digitalIntensity: Number(
        model[
          IWorkingSessionsAnalyticsActivityEnum.DigitalIntensity
        ]
      ) || 0,
      workingHours: Number(
        model[
          IWorkingSessionsAnalyticsActivityEnum.TotalSessionDuration
        ]
      ) || 0,
      timeInCalls: Number(
        model[
          IWorkingSessionsAnalyticsActivityEnum.TotalSessionCallDuration
        ]
      ) || 0,
    };
  }
  static domainToRest(
    entity: UserAllScoresResult
  ): UserAllScoresDto {
    return {
      ...entity,
      screenTime: entity.screenTime.toString(),
      focus: entity.focus.toString(),
      digitalIntensity: entity.digitalIntensity.toString(),
      workingHours: entity.workingHours.toString(),
      timeInCalls: entity.timeInCalls.toString()
    };
  }
}

export class AllScoresMapperV2
{
  persistenceToDomain(model: UserAllScoresV2Raw): UserAllScoresResult {
    return AllScoresMapperV2.persistenceToDomain(model);
  }

  static persistenceToDomain(
    model: UserAllScoresV2Raw
  ): UserAllScoresResult {
    if (!model) {
      console.log("Invalid result from scores query")
      return {}
    }
    return {
      screenTime: Number(
        model[
          IWorkingSessionsAnalyticsActivityEnumV2.TotalActivityDuration
        ] ?? 0
      ) || 0,
      focus: Number(
        model[
          IWorkingSessionsAnalyticsActivityEnumV2.FocusPercentage
        ] ?? 0
      ) || 0,
      digitalIntensity: Number(
        model[
          IWorkingSessionsAnalyticsActivityEnumV2.DigitalIntensity
        ] ?? 0
      ) || 0,
      workingHours: Number(
        model[
          IWorkingSessionsAnalyticsActivityEnumV2.TotalSessionDuration
        ] ?? 0
      ) || 0,
      timeInCalls: Number(
        model[
          IWorkingSessionsAnalyticsActivityEnumV2.TotalSessionCallDuration
        ] ?? 0
      ) || 0,
    };
  }
}
